import {FC, ReactNode, Fragment, useState} from 'react';
import {Tab} from '@headlessui/react'
import Link from "next/link";
import classnames from 'classnames';
import parse from 'html-react-parser';

interface Tabs {
  wrapperClassNames?: any
  containerClassNames?: any
  heading: string
  headingClassNames?: any
  headingEmphasis: string
  headingEmphasisClassNames?: any
  tabs?: any
  children?: ReactNode | ReactNode[]
}

// const tabs = [
//   {name: 'Step 1', current: true},
//   {name: 'Step 2', current: false},
//   {name: 'Step 3', current: false},
//   {name: 'Step 4', current: false},
//   {name: 'Step 5', current: false},
//   {name: 'Step 6', current: false},
// ]

const Tabs: FC<Tabs> = ({
                          wrapperClassNames,
                          containerClassNames,
                          heading,
                          headingClassNames,
                          headingEmphasis,
                          headingEmphasisClassNames,
                          tabs,
                          children
                        }) => {

  return (
    <section
      className={classnames(
        wrapperClassNames && Object.values(wrapperClassNames),
      )}
    >
      <div className={classnames(
        containerClassNames && Object.values(containerClassNames),
      )}
      >
        <h2
          className={classnames(
            headingClassNames && Object.values(headingClassNames),
            "!px-3"
          )}
        >
          {heading}&nbsp;
          <span
            className={classnames(
              headingEmphasisClassNames && Object.values(headingEmphasisClassNames),
            )}
          >
          {headingEmphasis}
        </span>
        </h2>
        <Tab.Group>
          {/* NOTE Desktop Tabs */}
          <Tab.List className="block">
            <div className="flex flex-wrap justify-center md:justify-start px-3" aria-label="Tabs">
              {tabs.map((tab, index) => (
                <Tab
                  key={tab.name}
                  className={({selected}) => classnames(
                    selected ? 'bg-indigo-100 text-indigo-700' : 'text-white hover:text-gray-700',
                    'px-3 py-2 font-medium text-sm rounded-md'
                  )}
                  // aria-current={tab.current ? 'page' : undefined}
                >
                  Step {index + 1}
                </Tab>
              ))}
            </div>
          </Tab.List>
          <Tab.Panels
            className={classnames(
              "px-3 pt-4"
            )}
          >

            {tabs.map((tab, tabPanelIndex) => (
              <Tab.Panel key={`tab-panel-${tabPanelIndex}`}>
                <h3 className={classnames(
                  "text-2xl font-bold py-2 text-[#ff6600]"
                )}>
                  {tab.heading}
                </h3>

                {tab.items.map((item, tabPanelItemIndex) => (
                  <Fragment key={`tab-panel-item-${tabPanelItemIndex}`}>
                    {/* NOTE Item Heading */}
                    <p
                      className={classnames(
                        "text-lg pb-2 text-[#17aaab]"
                      )}>
                      <strong>{item.heading}</strong>
                    </p>
                    {/* NOTE Item Content */}
                    {item.content && item.content.map((content, itemContentIndex) => (
                      <p
                        key={`tab-panel-item-content-${itemContentIndex}`}
                        className={classnames(
                          "text-lg pb-2 text-white"
                        )}
                      >
                        {parse(content)}
                      </p>
                    ))}
                  </Fragment>
                ))}
              </Tab.Panel>
            ))}

            {/*<Tab.Panel>*/}
            {/*  /!* NOTE Heading *!/*/}
            {/*  <h3 className={classnames(*/}
            {/*    "text-2xl font-bold py-2"*/}
            {/*  )}>*/}
            {/*    Regular 15 - 30 Minute Appointments*/}
            {/*  </h3>*/}
            {/*  /!*NOTE Item Heading *!/*/}
            {/*  <p className={classnames(*/}
            {/*    "text-lg pb-2"*/}
            {/*  )}>*/}
            {/*    <strong>Appointment Process</strong>*/}
            {/*  </p>*/}
            {/*  /!* NOTE Item Content *!/*/}
            {/*  <p>*/}
            {/*    <strong>Description:</strong> Review of Aligner Progression, Adjustments as Needed.*/}
            {/*  </p>*/}
            {/*  <p className={classnames("pb-2")}>*/}
            {/*    <strong>Cost:</strong> no extra charge, normally $65 per appointment.*/}
            {/*  </p>*/}
            {/*</Tab.Panel>*/}

            {/*<Tab.Panel>*/}
            {/*  /!* NOTE Heading *!/*/}
            {/*  <h3 className={classnames(*/}
            {/*    "text-2xl font-bold py-2"*/}
            {/*  )}>*/}
            {/*    Regular 15 Appointment - Insertion of Retainers*/}
            {/*  </h3>*/}
            {/*  /!*NOTE Item Heading *!/*/}
            {/*  <p className={classnames(*/}
            {/*    "text-lg pb-2"*/}
            {/*  )}>*/}
            {/*    <strong>Appointment Process</strong>*/}
            {/*  </p>*/}
            {/*  /!* NOTE Item Content *!/*/}
            {/*  <p>*/}
            {/*    <strong>Description:</strong> Insertion of Retainers Once Aligner Treatment is Complete.*/}
            {/*  </p>*/}
            {/*  <p className={classnames("pb-2")}>*/}
            {/*    <strong>Cost:</strong> no extra charge, normally $65 per appointment.*/}
            {/*  </p>*/}
            {/*</Tab.Panel>*/}

          </Tab.Panels>
        </Tab.Group>
      </div>
    </section>
  )
}

export default Tabs
